<lib-app-value-view [caracIdStateValue]="currentCISV" [element]="currentCISV.element"></lib-app-value-view>
<div class="control-wrapper" *ngIf="showArrows()">
  <span class="arrow glyphicon glyphicon-chevron-left" (click)="setImageLower()"></span>
  <span class="bulle" *ngFor="let e of innerREL; index as i" [class.active]="currentIndex === i" (click)="setImage(i)"></span>
  <span class="arrow glyphicon glyphicon-chevron-right" (click)="setImageHigher()"></span>
</div>
